<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
            <v-server-table
              ref="vtable"
              :url="`${proxyUrl}contract/getByProvider`"
              :options="options"
              :columns="columns"
              @loaded="({data}) => onLoaded(data)"
            >
              <div slot="index" class="d-flex justify-content-center" slot-scope="{row, index}">
                  {{ index }}
              </div>
              <div slot="client_name" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.client.name }}
              </div>
              <div slot="sign_date" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.is_full ? row.sign_date : '-' }}
              </div>
              <div slot="price" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.is_full ? `${row.price}դր.` : '-' }}
              </div>
              <div slot="total_leftover" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ row.is_full ? `${parseFloat(getContractLeftover(row).toFixed(2))}դր.` : '-' }}
              </div>
               <div slot="details" class="d-flex row justify-content-center" slot-scope="{row}">
                  <div class="col-12">
                    <button
                      v-if="row.from_application && !row.is_full"
                      @click.stop="() => { 
                        $modal.show('fill-contract-details-modal', {...row, resetComponent})
                      }"
                      type="button" 
                      class="btn btn-primary btn-sm"
                    >
                      Լրացնել մանրամասները
                    </button>
                    <button
                      v-if="row.is_full"
                      @click.stop="() => { 
                        $modal.show('contract-details-modal', {...row, resetComponent})
                      }"
                      type="button" 
                      class="btn btn-primary btn-sm"
                    >
                      Մանրամասներ
                    </button>
                  </div>
                  <div v-if="row.from_application && row.is_full" class="col-12 mt-2">
                    <div
                      class="p-0"
                      v-tooltip="!row.is_sign && 'Պայմանագիրը դեռ չի հաստատվել մասնակցի կողմից'"
                    >
                      <button
                        @click="() => { 
                          $modal.show('order-modal', {contract: row, resetComponent}) 
                        }"
                        :disabled="!row.is_sign"
                        type="button" 
                        class="btn btn-primary btn-sm"
                      >
                        Գրանցել պատվեր
                      </button>
                    </div>
                  </div>
              </div>
              <div slot="contract" class="d-flex justify-content-center" slot-scope="{row}">
                <div class="row">
                  <button
                    v-if="row.organize && (row.organize.type === 'itender' && row.organize.report_document)"
                    @click.stop="() => { 
                      $modal.show('report-document-modal', {contract: row}) 
                    }"
                    type="button" 
                    class="btn btn-primary btn-sm col m-1"
                  >
                    <i class="fas fa-file-alt mr-1" /> Հաշվետվություն
                  </button>
                  <button
                    v-if="!row.from_application && (row.participant && row.participant.contract_document)"
                    @click.stop="() => { 
                      $modal.show('contract-document-modal', {contract: row}) 
                    }"
                    type="button"
                    class="btn btn-primary btn-sm col m-1"
                  >
                    <i class="fas fa-file-alt mr-1" /> Պայմանագիր
                  </button>
                </div>
              </div>
              <div slot="delete" class="d-flex justify-content-center">
                <i class="mdi mdi-delete text-danger" style="font-size: 30px; cursor: pointer;"></i>
              </div>
            </v-server-table>
        </div>
        <order-modal />
        <contract-details-modal />
        <fill-contract-details-modal />
        <specification-modal />
        <contract-document-modal />
        <report-document-modal />
        <!-- end col -->
      </div>
    </div>
  </div>
</template>

<script>
  import SpecificationModal from '@/components/modals/SpecificationModal'
  import ContractDocumentModal from '@/components/modals/ContractDocumentModal'
  import ReportDocumentModal from '@/components/modals/ReportDocumentModal'
  import OrderModal from './modals/OrderModal'
  import ContractDetailsModal from './modals/ContractDetailsModal'
  import FillContractDetailsModal from './modals/FillContractDetailsModal'

  export default {
    name: 'contracts',
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['index', 'code', 'client_name', 'sign_date', 'price', 'total_leftover', 'contract', 'details'],
        options: {
          rowClassCallback: function(row) {
            if(!row.is_full){
              return 'bg-light'
            }
          },
          sortable: [],
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns: ['create_date','end_date'],
          skin: 'table table-hover',
          dateFormat: "YYYY-mm-dd",
          headings: {
            index: 'Հ/Հ',
            code: 'Պայմանագրի ծածկագիր',
            client_name: 'Պատվիրատուի անվանում',
            sign_date: 'Կնքման ամսաթիվ',
            price: 'Ընդհանուր արժեք',
            total_leftover: 'Ընդհանուր մնացորդ ըստ պատվերների',
            contract: '',
            final_date: 'Վերջնաժամկետ',
            details: '',
          },
          filterable: true,
          texts: {
            count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: {SpecificationModal, ContractDetailsModal, ContractDocumentModal, FillContractDetailsModal, OrderModal, ReportDocumentModal},
    computed: {
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    methods: {
      consoleLog(e){
        console.log(e)
      },
      onLoaded({data}){
        const contractId = this.$route.params.id
        if(contractId){
          const contract = data.find(item => item.id === +contractId)
          this.$modal.show('order-modal', {contract: contract})
        }
      },
      getContractLeftover(row){
        const { lots } = row
        var leftover = 0;
        lots.forEach((lot) => {
          const count = lot.available + lot.supplied + lot.ordered;
          const priceUnit = lot.price / count
          leftover += +lot.available * priceUnit
        })
        return leftover;
      },
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
    },
  }
</script>
<style>
  .bg-light-grey{
    background-color: #e1e1e1;
  }
</style>